import { useMemo } from 'react';
import memoizeOne from 'memoize-one';
import { staticSidebarShortcutsResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/sidebar/static-sidebar-shortcuts/index.tsx';
import type { ProjectShortcut } from '@atlassian/jira-navigation-apps-resources/src/types.tsx';
import type { UseResourceCustomContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/types.tsx';
import { useResourceWithCustomRouterContext } from '@atlassian/jira-resource-with-custom-router-context/src/controllers/use-resource-with-custom-router-context/index.tsx';
import { useCanEditShortcuts } from '../can-edit-shortcuts/index.tsx';
import type { ShortcutsDataReturnType } from './types.tsx';
import { transformShortcuts } from './utils/index.tsx';

const transformShortcutsMemo = memoizeOne((a, b) => transformShortcuts(a, b));
const emptyData: ShortcutsDataReturnType['data'] = [];

export const useShortcutsData = (
	customContext?: UseResourceCustomContext,
): ShortcutsDataReturnType => {
	const canEdit = useCanEditShortcuts(customContext);
	const { data, loading, error, refresh } = useResourceWithCustomRouterContext<
		ProjectShortcut[] | null
	>(staticSidebarShortcutsResource, customContext);
	const items = useMemo(() => data && transformShortcutsMemo(data, canEdit), [data, canEdit]); // canEdit should be the same for all shortcuts per person, per project

	return { data: items || emptyData, loading, error, refresh };
};
